import { render, staticRenderFns } from "./PFAnnextureStatement.vue?vue&type=template&id=462315a7&scoped=true"
import script from "./PFAnnextureStatement.vue?vue&type=script&lang=js"
export * from "./PFAnnextureStatement.vue?vue&type=script&lang=js"
import style0 from "./PFAnnextureStatement.vue?vue&type=style&index=0&id=462315a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462315a7",
  null
  
)

export default component.exports